<template>
  <b-card :title="details.vectorName">
    <Spinner v-if="loading"/>

    <template v-else>
      <div class="d-flex align-items-center">
        <span class="mr-2">Consumo</span>

        <DatePicker v-if="isDaily" v-model="date" :the-max-restriction-date="dateFromResponse"/>
        <MonthPicker v-else v-model="date" />
      </div>

      <div class="consumption-today-value text-center h4">
        {{ (isDaily ? details.value : details.monthValue) | formatNullableDecimal }} [{{ details.mu }}]
      </div>

      <div id="consumption-grid">
        <template v-if="isDaily">
          <div>Settimana:</div>
          <div>{{ details.weekValue | formatNullableDecimal }} [{{details. mu }}]</div>
          <div>
            <Delta :value-delta="details.weekDelta"/>
          </div>
        </template>

        <div>{{ month }} {{ year }}:</div>
        <div>{{ details.monthValue | formatNullableDecimal }} [{{ details.mu }}]</div>
        <div>
          <Delta :value-delta="details.monthDelta"/>
        </div>
      </div>

      <LastAvailableDataDateLabel v-if="dateFromResponse" :date="dateFromResponse"/>
    </template>
  </b-card>
</template>

<script>
import moment from 'moment';
import vectorMixin from './vector';
import { ACTION_DETAILS } from '@/store/modules/dashboard/actions';

export default {
  name: 'Consumption',

  mixins: [vectorMixin],

  props: {
    vector: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      localDate: moment().subtract(1, 'days'),

      details: {
        vectorName: null,

        value: null,
        mu: null,

        weekValue: null,
        weekDelta: null,

        monthValue: null,
        monthDelta: null,
      },

      isDaily: true,
    };
  },

  methods: {
    async loadData(force = false) {
      if (this.loading && !force) {
        return;
      }

      try {
        this.loading = true;

        let { date, ...details } = await this.$store.dispatch(
          `dashboard/${ACTION_DETAILS}`,
          {
            vector: this.vector,
            date: this.isDaily ? this.date : moment(this.date).startOf('month'),
          },
        );

        this.details = details;

        if (this.details.value === null) {
          this.isDaily = false;
        }

        if (date) {
          this.setDateFromResponse = true;
          this.localDate = moment(date);
        }
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    month() {
      return this.monthsNames[this.date.month()];
    },

    year() {
      return this.date.year();
    },

    monthsNames() {
      return this.$store.state.utils.months;
    },
  },
}
</script>

<style>
.consumption-today-value {
  padding: 15px;
  margin: 10px 15px;
}

#consumption-grid {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 3fr 1.5fr 1fr;
}

#consumption-grid > div {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/widgets/Consumption.vue